<template>
    <div>

        <div class="product-listing__container js-product-listing">
            <div class="preloader-container" v-if="fetchInProgress">
                <span class="loader"></span>
            </div>
            <div v-for="(product, index) in products" :key="product.id" :class="['product-info-box js-product-info-box']"
                :id="product.id">
                <div :id="index + '-product-id'" :class="{
                    'product-info-box__add-list-wrapper':
                        activeIndex !== index,
                    'product-info-box__add-list-wrapper product-info-box__add-list-wrapper--active':
                        activeIndex === index
                }">
                    <div class="product-info-box__add-list-close-btn js-product-info-box__add-list-close-btn"
                        @click="removeActive(index)"></div>
                    <span class="product-info-box__add-list-title">Add to List</span>
                    <List v-if="kadraGlobal.userId !== '0'" :favorites="favorites" :productWishlist="productWishlist"
                        :wishlist="wishlist" :product="product" />
                </div>
                <div class="product-info-box__wrapper">
                    <div class="product-info-box__header">
                        <label class="product-info-box__header-checkbox">
                            <input type="checkbox" name="compare" v-model="checkedCompare" v-bind:value="product" />
                            <span>Compare</span>
                        </label>
                        <a v-if="kadraGlobal.userId !== '0' &&
                            userType !== 'salesman'
                            " @click="setActive(index)"
                            class="product-info-box__header-cta-btn js-product-info-box__header-cta-btn"
                            href="javascript:;">
                            <SvgIcon class="product-info-box__header-cta-btn-icon" iconName="ico-plus-regular" />
                            <span>Add to List</span>
                        </a>
                    </div>
                    <span class="product-info-box__label new" v-if="product.new_badge === '1'">NEW</span>
                    <span class="product-info-box__label hot" v-if="product.hot_badge === '1'">HOT</span>

                    <div class="product-info-box__img">
                        <a class="product-info-box__img-link" :href="kadraGlobal.Url + '/product/' + product.slug"
                            @click.prevent.stop="openProductPopup(product.id)">
                            <img class="product-info-box__img-photo js-product-img" :src="product.image ||
                                kadraGlobal.icons +
                                '/src/assets/images/plch.jpg'
                                " alt="" />
                        </a>
                        <a class="product-info-box__img-zoom" @click="
                            setIndex(index);
                        showPopup();
                        " v-if="product.thumb">
                            <SvgIcon class="search-filter__body-icon" iconName="ico-search-plus" />
                        </a>
                    </div>

                    <div class="product-info-box__title-wrapper">
                        <span v-if="product.pa_brand" class="product-info-box__pretitle" v-html="TranslateProductAttribute(
                            'pa_brand',
                            parseInt(product.pa_brand)
                        )
                            "></span>
                        <span v-else class="product-info-box__pretitle">-</span>
                        <a :href="kadraGlobal.Url + '/product/' + product.slug"
                            @click.prevent.stop="openProductPopup(product.id)">
                            <h3 class="product-info-box__title js-product-info-box__title"
                                :style="{ height: calculateMaxHeight() }" v-html="product.title"></h3>
                        </a>
                    </div>

                    <div class="product-info-box__product-desc-wrapper">
                        <div class="product-info-box__product-desc js-product-desc-wrap">
                            <span class="product-info-box__product-desc-title">UPC:</span>
                            <span v-html="product.upc"></span>
                        </div>

                        <div class="product-info-box__product-desc js-product-desc-wrap">
                            <span class="product-info-box__product-desc-title">SKU:</span>
                            <span v-html="product.sku"></span>
                        </div>

                        <div
                            class="product-info-box__product-desc product-info-box__product-desc--alt js-product-desc-alt-wrap">
                            <span :title="RenderAttributes(product)">{{
                                RenderAttributes(product)
                            }}</span>
                        </div>
                        <div
                            class="product-info-box__product-desc product-info-box__product-desc--alt js-product-desc-alt-wrap">
                            <span class="product-info-box__product-desc-title">CASE PACK:</span>
                            <span v-if="product.pack === 0" v-html="'1 UNIT'"></span>
                            <span v-else-if="product.pack === 1" v-html="product.pack + ' UNIT'"></span>
                            <span v-else v-html="product.pack + ' UNITS'"></span>
                        </div>
                    </div>

                    <div class="product-info-box__total-wrapper" v-if="kadraGlobal.userId !== '0'">
                        <div class="product-info-box__total-price-wrapper">
                            <span v-if="product.price !== product.priceR" class="product-info-box__total-price product-info-box__total-price--sale" style="text-decoration: line-through;">
                                <span>$</span> {{ FormatProductPrice(product, true) }}
                            </span>
                            <span class="product-info-box__total-price"><sup>$</sup> {{ FormatProductPrice(product)
                            }}</span>
                            <span class="product-info-box__total-price-unit">/unit</span>
                        </div>
                        <div class="product-info-box__total-quantity-wrapper">
                            <div class="product-info-box__total-quantity-out" v-if="product.stockStatus !== 'instock'">
                                <span class="product-info-box__total-quantity-out-icon"></span>
                                <span class="product-info-box__total-quantity-out-text">Out of Stock</span>
                            </div>
                            <div class="product-info-box__total-quantity-contaner" v-if="userType != 'salesman'">
                                <span
                                    class="product-info-box__total-quantity-toggle product-info-box__total-quantity--minus"
                                    @click="
                                        removeFromCart(
                                            product.id,
                                            index,
                                            product.pack
                                        )
                                        "></span>
                                <input
                                    :class="{'is-focused': focusedInput === product.id}"
                                    type="text"
                                    :value="GetFormattedQty(product.id)"
                                    @input="updateValue($event, product)"
                                    @keyup="onEnter(product.id, index, product.pack)"
                                    min="0"
                                    maxlength="5"
                                    placeholder="0"
                                    @focus="handleFocus(product.id)"
                                    @blur="handleBlur" />
                                <span v-if="checkCart(product)"
                                    class="product-info-box__total-quantity-toggle product-info-box__total-quantity--plus"
                                    @click="
                                        addToCart(
                                            product.id,
                                            index,
                                            product.pack
                                        )
                                        "></span>
                            </div>
                            <div class="product-info-box__total-cases-wrap" v-if="userType != 'salesman'">
                                <template v-if="activeIndex2 !== index">
                                    <span v-if="cart[product.id]"
                                        class="cart__items-item-quantity-cases cart__items-item-quantity-cases--has-item">Units
                                        in cart</span>
                                    <span v-else class="product-info-box__total-cases">Units in cart</span>
                                </template>
                            </div>
                            <div class="salesman-notification-wrap" v-if="userType === 'salesman'">
                                <span class="salesman-notification">Please select a customer.</span>
                            </div>
                            <span v-if="activeIndex2 === index"
                                class="product-info-box__total-quantity-loader">Processing...</span>
                        </div>
                    </div>
                    <div class="product-info-box__more-wrapper" v-if="product.acfFields" @click="toggleReadMore(index)">
                        <a class="product-info-box__more" href="javascript:;">Read more</a>
                    </div>
                </div>
                <!-- .product-info-box__wrapper -->
                <div :class="{
                    'product-info-box__hover-content product-info-box__hover-content--padding':
                        showHoverInfo !== index,
                    'product-info-box__hover-content product-info-box__hover-content--toggle product-info-box__hover-content--padding':
                        showHoverInfo === index
                }">
                    <div v-if="kadraGlobal.userId !== '0'">
                        <div v-if="product.acfFields" class="product-info-box__hover-content-header">
                            <span v-html="product.acfFields"></span>
                        </div>
                    </div>
                    <a href="javascript:" class="js-popup-login-trigger" @click="openLoginPopup(product.id)" v-else>
                        <button class="addToCart loginPrice" data-id="2617">
                            LOGIN TO SEE PRICE
                        </button>
                    </a>
                    <div class="product-info-box__hover-content-details" v-if="product.description">
                        <span class="product-info-box__hover-content-details-title">Additional Product Details</span>
                        <div class="product-info-box__hover-content-details-list" v-html="product.description"></div>
                    </div>
                </div>
            </div>
            <!-- .product-info-box -->
            <transition name="fade-in">
                <div class="product-info-box-popup" v-if="fullImgUrl" @click.self="closePopup()">
                    <a href="javascript:;" class="vue-popup__close vue-popup__close--alt" @click.self="closePopup()"></a>
                    <div class="product-info-box-popup-wrapper">
                        <img :src="fullImgUrl" alt="" />
                    </div>
                </div>
            </transition>
            <transition name="fade-in-fast">
                <ProductPopupDetail v-if="showProductPopup" :productId="ProductPopupId" @closePopup="closeProductPopup">
                </ProductPopupDetail>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import List from './List.vue';
import SvgIcon from '../../../base/SvgIcon/SvgIcon.vue';
import ProductPopupDetail from './ProductPopupDetail.vue';
import Global from '../../../../../js/site/global';


export default {
    props: [
        'btn',
        'favorites',
        'productWishlist',
        'wishlist',
        'addToCartLoading',
        'cart',
        'curentCount',
        'sort'
    ],
    components: {
        List,
        SvgIcon,
        ProductPopupDetail
    },
    computed: mapState({
        ProductAttrs: state => state.Listing.attributes,
        fetchInProgress: state => state.Pagination.fetchInProgress,
        products: state => state.Listing.products,
        loadingId: state => state.Cart.loadingId
    }),
    beforeMount() {
        let arr = localStorage.getItem('compare-' + this.kadraGlobal.userId);
        arr !== null ? (arr = JSON.parse(arr)) : (arr = []);
        this.checkedCompare = arr;
        this.$emit('addToCompare', this.checkedCompare);
    },
    data() {
        return {
            count: 50,
            productToShow: [],
            checkedCompare: [],
            activeIndex: undefined,
            activeIndex2: undefined,
            kadraGlobal: kadraGlobal,
            index: null,
            preloader: true,
            inputDelay: null,
            showHoverInfo: undefined,
            checkScroll: 0,
            firsttime: false,
            userType: window.usingcustomer.session.type,
            CartQty: [],
            AddToCartTimeouts: {},
            ProductPopupId: 0,
            showProductPopup: false,
            freezeBody: false,
            fullImgUrl: '',
            timeouts: {},
            delayTime: 1000,
            focusedInput: null,
        };
    },
    watch: {
        checkedCompare() {
            this.$emit('addToCompare', this.checkedCompare);
        },
        addToCartLoading() {
            if (!this.addToCartLoading) {
                this.activeIndex2 = undefined;
                document.body.style.pointerEvents = 'auto';
                document.body.style.opacity = '1';
            }
        },
        cart() {
            this.UpdateCartQty();
        },
    },
    mounted() {
        this.removePreloader();
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.activeIndex = undefined;
            }
        });
        const specifiedElement = document.getElementsByClassName(
            'product-info-box__add-list-wrapper--active'
        );
        const a = document.getElementsByClassName(
            'js-product-info-box__header-cta-btn'
        );
        document.addEventListener('click', event => {
            if (specifiedElement.length !== 0) {
                const isClickInside = specifiedElement[0].contains(
                    event.target
                );
                let flag = false;
                a.forEach(element => {
                    if (element.contains(event.target)) {
                        flag = true;
                    }
                });
                if (!isClickInside && !flag) {
                    this.activeIndex = undefined;
                }
            }
        });
        this.UpdateCartQty();
    },
    updated() {
        const popup = document.querySelector(
            '.product-info-box__add-list-wrapper--active'
        );
        if (popup !== null) {
            const product = popup.parentElement;
            const position = product.offsetTop - window.scrollY;
            const popupHeight = popup.offsetHeight;
            if (position < popupHeight) {
                popup.classList.add(
                    'product-info-box__add-list-wrapper--active-bottom'
                );
            } else {
                popup.classList.remove(
                    'product-info-box__add-list-wrapper--active-bottom'
                );
            }
        }
    },
    methods: {
        handleFocus(id) {
            this.focusedInput = id;
        },
        handleBlur() {
            this.focusedInput = null;
        },
        calculateMaxHeight() {
            const titleElements = document.querySelectorAll('.js-product-info-box__title');

            let maxHeight = 0;

            for (const element of titleElements) {
                const height = element.clientHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            }

            return maxHeight ? maxHeight.toString() + 'px' : 'auto';
        },
        showPopup() {
            const index = this.index;
            const body = document.querySelector('body');

            this.fullImgUrl = this.products[index].image;
            body.classList.add('scroll-disabled');
        },

        closePopup() {
            this.fullImgUrl = null;
            const body = document.querySelector('body');
            body.classList.remove('scroll-disabled');
        },

        updateValue(event, product) {
            let val = event.target.value;
            const max = event.target.maxLength;

            val = val.replace(/[^0-9]/g, '');

            if (val.length > max) {
                val = val.slice(0, max);
                /* event.target.value = val; */
            }

            if (val === '') {
                val = '0';
            }

            this.CartQty[product.id] = parseInt(val) || 0;
            event.target.value = val;
        },
        getCasePack() {
            if (this.product.pack === '') {
                return 1;
            }
            return this.product.pack;
        },
        removeAllCompare() {
            this.checkedCompare = [];
        },
        goToUrl(event, url, id) {
            event.preventDefault();
            const curentUrl = window.location.href;
            const obj = {
                url: curentUrl,
                id: id
            };
            localStorage.setItem('goBackUrl', JSON.stringify(obj));
            window.location.href = url;
        },
        toggleReadMore(index) {
            if (window.innerWidth < 1025) {
                if (this.showHoverInfo === index) {
                    this.showHoverInfo = undefined;
                } else {
                    this.showHoverInfo = index;
                }
            }
        },
        openLoginPopup(ele) {
            const popup = document.getElementsByClassName(
                'js-popup-login-form'
            );
            popup[0].classList.add('active');
            popup[0].setAttribute('data-id', ele);
        },
        setActive(index) {
            this.activeIndex === index
                ? (this.activeIndex = undefined)
                : (this.activeIndex = index);
        },
        removeActive() {
            this.activeIndex = undefined;
        },
        goTo() {
            let obj = localStorage.getItem('goBackUrl');
            if (obj !== null) {
                obj = JSON.parse(obj);
                const target = document.getElementById(obj.id);
                if (target) {
                    jQuery([document.documentElement, document.body]).scrollTop(
                        jQuery(target).offset().top - 200
                    );
                }
                localStorage.removeItem('goBackUrl');
            }
        },
        // on qty input change
        onEnter(id, index, pack) {
            const val = event.target.value.trim() === '' ? 0 : parseInt(event.target.value) || 0;
            if (val < 0) {
                event.target.value = ''; // Keep it visually empty
                return false;
            }
            this.CartQty[id] = val;
            this.DelayedUpdateQty(id, index, pack, val);
        },
        // increase qty
        async addToCart(id, index, pack) {
            if (this.loadingId === null) {
                await this.$store.dispatch('setLoadingId', id);
            }
            if (this.loadingId !== id) return;
            this.CartQty[id] = (parseInt(this.CartQty[id]) || 0) + 1;
            if (this.CartQty[id] === 1) {
                this.CartQty = { ...this.CartQty };
            }
            clearTimeout(this.timeouts[id]);
            this.timeouts[id] = setTimeout(() => {
                this.freezeBody = true;
                document.body.style.pointerEvents = 'none';
                document.body.style.opacity = '0.7';
                this.DelayedUpdateQty(id, index, pack, this.CartQty[id]);
            }, this.delayTime);
            this.freezeBody = false;
        },
        // decrease qty
        async removeFromCart(id, index, pack) {
            if (this.loadingId === null) {
                await this.$store.dispatch('setLoadingId', id);
            }
            if (this.loadingId !== id) return;
            this.CartQty[id] = Math.max(
                0,
                (parseInt(this.CartQty[id]) || 0) - 1
            );
            clearTimeout(this.timeouts[id]);
            this.timeouts[id] = setTimeout(() => {
                this.freezeBody = true;
                document.body.style.pointerEvents = 'none';
                document.body.style.opacity = '0.7';
                this.DelayedUpdateQty(id, index, pack, this.CartQty[id]);
            }, this.delayTime);
            this.freezeBody = false;
        },
        // delayed send qty to WC
        DelayedUpdateQty(ProductId, Index, Pack, Value) {
            if (this.AddToCartTimeouts[ProductId]) {
                clearTimeout(this.AddToCartTimeouts[ProductId]);
            }
            this.AddToCartTimeouts[ProductId] = setTimeout(() => {
                if (Index !== null) {
                    this.activeIndex2 = Index;
                }
                this.$store.dispatch('addMany', {
                    id: ProductId,
                    val: Value,
                    pack: Pack
                });
            }, 500);
        },
        // nice formatted qty value
        GetFormattedQty(ProductId) {
            return this.CartQty[ProductId] === 0 ? '' : (parseInt(this.CartQty[ProductId]) || '');
        },
        // format price
        FormatProductPrice(product, showRegularPrice) {
            return Global.functions.formatNumber(parseFloat(product[showRegularPrice ? 'priceR' : 'price']));
        },
        // convert brand ID into name
        //GetBrandName(Id) {
        //    this.ProductAttrs.
        //},
        // clone qtys from store to local variable
        UpdateCartQty() {
            this.CartQty = { ...this.cart };
        },

        checkCart() {
            return true;
        },
        setIndex(index) {
            this.index = index;
        },
        removePreloader() {
            setTimeout(() => {
                this.preloader = false;
            }, 20);
        },
        /**
         * @description add equal height to products title
         */
        equalHeights: elName => {
            setTimeout(() => {
                const products = document.getElementsByClassName(elName);
                let x = 0;

                Array.from(products).forEach(el => {
                    el.style.height = 'auto';
                    if (el.offsetHeight > x) {
                        x = el.offsetHeight;
                    }
                });

                Array.from(products).forEach(el => {
                    el.style.height = `${x}px`;
                });
            }, 500);
        },

        RenderAttributes(Product) {
            const Details = [
                this.TranslateProductAttribute(
                    'pa_size',
                    parseInt(Product.pa_size)
                ),
                this.TranslateProductAttribute(
                    'pa_color',
                    parseInt(Product.pa_color)
                )
            ].filter(item => item !== null);
            return Details.join(' | ');
        },

        TranslateProductAttribute(Term, Id) {
            if (!Id) {
                return null;
            }
            const Obj = this.ProductAttrs[Term].find(el => el.term_id === Id);
            return Obj ? Obj.name : null;
        },

        openProductPopup(id) {
            document.querySelector('body').classList.add('popup-open');
            this.ProductPopupId = id;
            this.showProductPopup = true;
        },
        closeProductPopup() {
            document.querySelector('body').classList.remove('popup-open');
            const body = document.querySelector('body');
            body.classList.remove('scroll-disabled');
            this.showProductPopup = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.products-slider__wrapper .slick-slide {
    padding: 0 10px;
}

.product-listing__container {
    position: relative;

    .product-info-box {
        @include mq(1560px) {
            @include mq(1350px, min) {
                margin-right: 1.85%;
                width: 18.5%;

                &:nth-child(5n) {
                    margin-right: 0;
                }
            }
        }

        @include mq(1349px) {
            @include mq(1025px, min) {
                margin-right: 2.6%;
                width: 23%;

                &:nth-child(4n) {
                    margin-right: 0;
                }
            }
        }
    }
}

.product-info-box__total-quantity-wrapper input {
    &::placeholder {
        color: $white;
    }

    @include mq(1200px) {
        @include mq(1025px, min) {
            width: 80px;
        }
    }
}

.product-info-box__add-list-wrapper--active-bottom {
    top: 0;
    transform: translate(-50%, 20%);

    &::after {
        bottom: auto;
        top: -12px;
        border-bottom: 12px solid $white;
        border-top: none;
    }
}

.loginPrice {
    margin-top: 11px !important; // sass-lint:disable no-important
    margin-bottom: 11px;
}

.product-info-box__total-cases-wrap {
    display: flex;
}

.product-info-box__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.product-info-box__product-desc-wrapper {
    margin-top: auto !important;
}

.product-info-box__header-cta-btn {
    display: flex;
    align-items: center;

    span {
        color: $black;
        font-family: $font-second;
        font-weight: 600;
        font-size: 12px;
        transition: 0.3s ease;
    }
    .product-info-box__header-cta-btn-icon {
        color: $theme-yellow;
        margin-right: 5px;
        font-size: 14px;
        margin-top: -2px;
        transition: 0.3s ease;
    }

    &:hover {
        span {
            color: $theme-yellow;
        }
    }
}
.product-info-box__header-checkbox span{
    font-weight: 600;
}

.preloader-container {
    position: absolute;
    width: 100%;
    height: 100%;

    .loader {
        position: absolute;
        z-index: 9999;
        top: calc(100% + 200px);
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 100px;

        @include mq($lg) {
            left: 48%;
            font-size: 35px;
        }

        @include mq(640px) {
            left: 45%;
        }
    }
}

.product-info-box__total-price--sale {
    font-size: 11px;
    font-weight: 400;
    font-family: $font-main;
    margin-bottom: 0;
}

.is-focused {
    &::placeholder {
        color: transparent !important;
    }
}
</style>
